import React from "react";
import solar from '../images/solarmodul/modul.png';

const FancyFeatureGrid = () => {
  return (
    <div className="w-full max-w-7xl mx-auto py-12 px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 auto-rows-[160px] md:auto-rows-[180px] lg:auto-rows-[160px]">

        {/* 88,95 % Leistung */}
        <div className="bg-primary text-white rounded-xl flex flex-col items-center justify-center text-center font-semibold p-6 lg:col-span-1 lg:row-span-2 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer">
          <div className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-2">88,95 %</div>
          <div className="text-lg sm:text-xl lg:text-2xl font-normal">Leistung</div>
          <div className="text-sm sm:text-base lg:text-lg font-light mt-2">über 30 Jahre garantiert</div>
        </div>

{/* Full Black Module */}
<div className="bg-secondary-light rounded-xl lg:col-span-2 lg:row-span-2 relative overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-secondary-lighter cursor-pointer">
  {/* Text links mit max-width */}
  <div className="flex flex-col justify-start p-6 relative z-10 text-left max-w-[45%]">
    <div className="text-secondary-dark text-sm sm:text-base lg:text-lg mb-1">Hocheffiziente</div>
    <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-tertiary mb-2">Full Black Module</div>
    <div className="text-secondary-dark text-sm sm:text-base lg:text-lg leading-relaxed">
      Durch geringeren Zellwiderstand erzielen die Solarmodule eine höhere Leistung als Standardmodule.
    </div>
  </div>

  {/* Bild leicht nach rechts */}
  <div className="absolute bottom-0 right-0 w-4/5 h-auto">
    <img
      src={solar}
      alt="Full Black Modul"
      className="w-full h-auto object-contain"
      style={{ transform: 'translate(10%, 30%) scale(1.4)' }} // 10% nach rechts, 30% nach oben
    />
  </div>
</div>



        {/* 475Wp */}
        <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center text-center p-6 lg:col-span-1 lg:row-span-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-secondary-lighter cursor-pointer">
          <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-tertiary mb-2">475 Wp</div>
          <div className="text-secondary-dark text-sm sm:text-base lg:text-lg">Hohe Leistungstoleranz bis zu 5 W positiv</div>
        </div>

        {/* Hochbeständige Zelltechnologie */}
        <div className="bg-secondary rounded-xl flex items-center justify-center text-center text-lg sm:text-xl lg:text-2xl font-semibold text-tertiary p-6 lg:col-span-2 lg:row-span-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer">
          Hochbeständige Zelltechnologie
        </div>

        {/* Brandschutzklasse A */}
        <div className="bg-primary text-white rounded-xl flex flex-col items-center justify-center text-center font-semibold p-6 lg:col-span-1 lg:row-span-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-primary-dark cursor-pointer">
          <div className="text-lg sm:text-xl lg:text-2xl font-bold mb-2">Brandschutzklasse A</div>
        </div>

        {/* Modulwirkungsgrad 23,8% */}
        <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center text-center p-6 lg:col-span-1 lg:row-span-2 lg:row-start-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-secondary-lighter cursor-pointer">
          <div className="text-base sm:text-lg lg:text-xl font-bold text-tertiary mb-2">Modulwirkungsgrad</div>
          <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-primary">24,5%</div>
        </div>

        {/* Maximale Energieausbeute */}
        <div className="bg-secondary rounded-xl flex items-center justify-center text-center text-lg sm:text-xl lg:text-2xl font-semibold text-tertiary p-6 lg:col-span-2 lg:row-span-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer">
          Maximale Energieausbeute
        </div>

        {/* ABC Technologie */}
        <div className="bg-secondary-light rounded-xl flex items-center justify-center text-center text-lg sm:text-xl lg:text-2xl font-semibold text-tertiary p-6 lg:col-span-2 lg:row-span-1 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-secondary-lighter cursor-pointer">
          ABC Technologie
        </div>

      </div>
    </div>
  );
};

export default FancyFeatureGrid;
